import { HTMLAttributes } from "react"

export default function Express(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="23.5" fill="black" stroke="white" />
      <path
        d="M40 32.523C38.8361 32.81 38.1163 32.5354 37.4705 31.5954C36.0207 29.4904 34.4204 27.4818 32.8761 25.4361C32.677 25.1714 32.4703 24.9116 32.2125 24.5827C30.3849 26.9722 28.5599 29.2479 26.8473 31.6152C26.2347 32.4612 25.5914 32.8298 24.448 32.5305L31.3191 23.5932L24.9227 15.5217C26.0228 15.3139 26.7834 15.4203 27.4573 16.3751C28.9454 18.4827 30.5866 20.4888 32.2227 22.6112C33.869 20.4962 35.4898 18.4876 37.0213 16.3999C37.6364 15.5539 38.2975 15.2323 39.4027 15.544C38.5655 16.62 37.7462 17.6787 36.9218 18.73C35.8089 20.1474 34.7164 21.5821 33.5627 22.9698C33.1518 23.4646 33.2182 23.7861 33.5857 24.2537C35.7196 26.9722 37.8279 29.7179 40 32.523ZM8.00766 23.4448C8.19143 22.5518 8.31395 21.6415 8.5692 20.7658C10.1007 15.4648 16.3797 13.2608 20.6933 16.5458C23.2202 18.4728 23.8481 21.1888 23.7231 24.2512H9.48042C9.26601 29.7451 13.3474 33.0623 18.5493 31.3703C20.3743 30.7766 21.4488 29.3914 21.9874 27.6599C22.2605 26.7916 22.7123 26.6556 23.5546 26.9029C23.1232 29.0698 22.1456 30.8805 20.1037 32.0135C17.0408 33.7104 12.6684 33.1612 10.3687 30.8039C9.01077 29.4186 8.43392 27.6945 8.17867 25.8318C8.14038 25.535 8.06126 25.2431 8 24.9488C8.0051 24.4474 8.00766 23.9461 8.00766 23.4448ZM9.50594 23.0762H22.3779C22.2937 19.1035 19.7412 16.2811 16.2521 16.2564C12.4234 16.2267 9.67185 18.9823 9.50594 23.0762Z"
        fill="white"
      />
    </svg>
  )
}
